import { Text } from "@/components/ui/text";
import type { ChatMemo } from "./types";
import dayjs from "dayjs";

interface ChatMemoItemProps {
  memo: ChatMemo;
  onClick: () => void;
  onDelete: () => void;
}

const ChatMemoItem = ({ memo, onClick, onDelete }: ChatMemoItemProps) => {
  const truncateContent = (content: string, maxLength: number = 100) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength) + "...";
  };

  return (
    <div
      className="cursor-pointer  transition-colors hover:bg-gray-50"
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <Text variant="label-lg" className="mb-2 font-bold line-clamp-1">
            {memo.title}
          </Text>
          <Text variant="body-light" className="mb-2 text-grey-50 line-clamp-2">
            {truncateContent(memo.content)}
          </Text>
          <div className="flex items-center justify-between">
            <Text variant="body-light" className="text-grey-50">
              {dayjs(memo.updatedAt).format("YYYY.MM.DD HH:mm")}
            </Text>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              className="flex h-10 w-10 shrink-0 items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.26037 0C4.40069 0 3.70379 0.696902 3.70379 1.55657V2.18468C3.70379 2.19728 3.70409 2.20981 3.70468 2.22227H0.740741C0.331641 2.22227 0 2.55391 0 2.96301V4.44449C0 4.85359 0.331641 5.18523 0.740741 5.18523H1.13851L1.74239 13.0357C1.81962 14.0396 2.65676 14.8149 3.66366 14.8149H9.66967C10.6766 14.8149 11.5137 14.0396 11.5909 13.0357L12.1948 5.18523H12.5926C13.0017 5.18523 13.3333 4.85359 13.3333 4.44449V2.96301C13.3333 2.55391 13.0017 2.22227 12.5926 2.22227H9.62883C9.62942 2.20981 9.62972 2.19728 9.62972 2.18468V1.55657C9.62972 0.696902 8.93282 0 8.07314 0H5.26037Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.07314 0.740741H5.26037C4.80979 0.740741 4.44453 1.106 4.44453 1.55657V2.18468C4.44453 2.20541 4.46134 2.22222 4.48208 2.22222H8.85143C8.87217 2.22222 8.88898 2.20541 8.88898 2.18468V1.55657C8.88898 1.106 8.52372 0.740741 8.07314 0.740741ZM5.26037 0C4.40069 0 3.70379 0.696902 3.70379 1.55657V2.18468C3.70379 2.19728 3.70409 2.20981 3.70468 2.22227H0.740741C0.331641 2.22227 0 2.55391 0 2.96301V4.44449C0 4.85359 0.331641 5.18523 0.740741 5.18523H1.13851L1.74239 13.0357C1.81962 14.0396 2.65676 14.8149 3.66366 14.8149H9.66967C10.6766 14.8149 11.5137 14.0396 11.5909 13.0357L12.1948 5.18523H12.5926C13.0017 5.18523 13.3333 4.85359 13.3333 4.44449V2.96301C13.3333 2.55391 13.0017 2.22227 12.5926 2.22227H9.62883C9.62942 2.20981 9.62972 2.19728 9.62972 2.18468V1.55657C9.62972 0.696902 8.93282 0 8.07314 0H5.26037ZM11.4519 5.18523H1.88144L2.48095 12.9789C2.52849 13.5969 3.04382 14.0741 3.66366 14.0741H9.66967C10.2895 14.0741 10.8048 13.5969 10.8524 12.9789L11.4519 5.18523ZM12.2518 4.44449H12.5926V2.96301H0.740741V4.44449H1.08153H1.48148H11.8519H12.2518ZM5.32518 11.3788C5.12194 11.402 4.93842 11.256 4.91527 11.0528L4.5018 7.42347C4.47865 7.22024 4.62463 7.03671 4.82787 7.01356C5.0311 6.9904 5.21463 7.13639 5.23778 7.33962L5.65125 10.9689C5.6744 11.1722 5.52841 11.3557 5.32518 11.3788ZM7.9059 11.3788C8.10914 11.402 8.29266 11.256 8.31581 11.0528L8.72928 7.42347C8.75243 7.22024 8.60645 7.03671 8.40321 7.01356C8.19998 6.9904 8.01645 7.13639 7.9933 7.33962L7.57983 10.9689C7.55668 11.1722 7.70267 11.3557 7.9059 11.3788Z"
                  fill="#808080"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMemoItem;
